import React from 'react';
import { appData } from 'Settings';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Redirect } from 'react-router-dom';
import * as reducers from '../store/reducers';
import { clearAuthMessage } from '../store/users/actions';

import HomepageHero from 'Components/HomepageHero';
import HomepageNavBar from 'Components/HomepageNavBar';
import HomepageMobileAppsMessage from 'Components/HomepageMobileAppsMessage';
import HomepageExplore from 'Components/HomepageExplore';
import HomepageTopics from 'Components/HomepageTopics';
import AppFeature from 'Components/AppFeature';
import GetStarted from 'Components/GetStarted';
import FlashMessage from 'Components/FlashMessage';
import { ROUTES } from 'Settings/route-strings';

class Homepage extends React.Component {
  componentWillUnmount() {
    this.props.clearAuthMessage();
  }

  render() {
    const {
      logoutMessage,
      activeUser,
      isFetchingActiveUser,
      isAuthTokenExpired,
      location,
    } = this.props;

    if (activeUser && !isAuthTokenExpired && !isFetchingActiveUser) {
      return (
        <Redirect to={{ pathname: ROUTES.EXPLORE, search: location.search }} />
      );
    }

    return (
      <main className="Page__content">
        <HomepageHero />
        <HomepageNavBar />
        <HomepageMobileAppsMessage />
        <HomepageExplore />
        <HomepageTopics />
        <a id="topics" />
        {appData.map(app => {
          if (app.published)
            return <AppFeature app={app} key={`appFeature-${app.slug}`} />;
        })}

        <GetStarted />
        {logoutMessage ? (
          <FlashMessage
            {...logoutMessage}
            animationType="fade"
            location="page-top"
          />
        ) : null}
      </main>
    );
  }
}

const mapStateToProps = state => {
  return {
    activeUser: reducers.getActiveUser(state),
    isFetchingActiveUser: reducers.getIsFetchingActiveUser(state),
    isAuthTokenExpired: reducers.isAuthTokenExpired(state),
    logoutMessage: reducers.getAuthMessage(state),
  };
};

export default withRouter(
  connect(mapStateToProps, { clearAuthMessage })(Homepage)
);
